import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { DataRoomShareableLink } from 'models/ShareableLink';
import { Button, Loader } from 'ncoded-component-library';
import ResolvePagination from 'components/ResolvePagination';
import { useTranslation } from 'react-i18next';
import {
  ActiveCell,
  CopyCell,
  CreatedCell,
  LinkManageCell,
  ProtectionCell,
  NumberAcessCell,
} from '../ShareableLinksTable/components';
import CreateShareableLinkContext from 'router/subrouters/DataRoom/providers/CreateShareableLink/CreateShareableLink.context';

import './ShareableLinksMobile.styles.scss';

type ShareableLinksMobileProps = {
  className?: string;
  isLoading: boolean;
  totalPages: number;
  shareableLinks: DataRoomShareableLink[];
  updateShareableLink: (link: DataRoomShareableLink) => void;
  onRowClick: (link: DataRoomShareableLink) => void;
};

const ShareableLinksMobile: React.FC<ShareableLinksMobileProps> = (props) => {
  const {
    className,
    isLoading,
    totalPages,
    shareableLinks,
    updateShareableLink,
    onRowClick,
  } = props;

  const { openCreateShareableLink } = useContext(CreateShareableLinkContext);

  const loading = useMemo(
    () => isLoading && !shareableLinks?.length,
    [isLoading, shareableLinks?.length],
  );

  const classes = classNames('shareable-links-mobile', { loading }, className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      {loading && <Loader />}

      <Button variant="outline" onClick={() => openCreateShareableLink()}>
        {t('createSecureLink')}
      </Button>

      <div
        className={classNames('shareable-links-mobile__links', 'white-panel')}
      >
        {shareableLinks.map((link) => {
          const { _id, name } = link;

          return (
            <div key={_id} onClick={() => onRowClick(link)}>
              <div className="info">
                <span className="name">{name}</span>
                <NumberAcessCell link={link} />

                <div className="access">
                  {t('created')}
                  {' : '}
                  <CreatedCell link={link} />
                </div>

                <ProtectionCell
                  link={link}
                  updateShareableLink={updateShareableLink}
                />
              </div>
              <div className="actions">
                <ActiveCell
                  link={link}
                  updateShareableLink={updateShareableLink}
                />
                <CopyCell link={link} />
                <LinkManageCell link={link} />
              </div>
            </div>
          );
        })}
      </div>

      <ResolvePagination totalPages={totalPages} />
    </div>
  );
};

export default ShareableLinksMobile;
